import { styled, Tooltip } from '@mui/material';

export const StyledTooltip = styled(Tooltip)`
    font-size: 14px;

    span {
        font-size: 14px;
    }
`;

export const TooltipTitle = styled('span')`
    display: flex;
    flex-direction: column;
    font-size: 14px;
`;
